module.exports = __webpack_public_path__ + "img/logo-trezor.7d1254f1.svg";